import Support from '../../../utils/support';

export default function () {
  const swiper = this;
  if (Support.touch || (swiper.params.watchOverflow && swiper.isLocked)) return;
  swiper.el.style.cursor = '';
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/framework7/components/swiper/swiper-class/components/core/grab-cursor/unsetGrabCursor.js
// module id = null
// module chunks = 